import React from "react";

const ProductPhoto = ({ productItem = {} }) => {
  const { photo, name } = productItem;
  return (
    <div className="w-full overflow-hidden rounded-lg">
      <img
        className="w-full object-cover hover:scale-110 transition-transform ease-in-out duration-200 cursor-pointer"
        src={photo}
        alt={name}
      />
    </div>
  );
};

export default ProductPhoto;
